import React from 'react';
import FeatureCards from "../../../components/FeatureCards/FeatureCards";
import CTA from "../../../components/Constant/cta/CTA";
import TimelineSection from "../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../components/WhySection/WhySection";
import LocationTimeline from "../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../components/ServiceCards/ServiceCards ";

export default function SecuritiesDealerLicenseSeychelles (){

    return (
        <main className='main'>

            <IntroSection
                title="Securities Dealer License – Seychelles"
                subtitle="The Most Popular Forex Brokerage License in the Offshore World"
                description =
                    "
                        The <b>Securities Dealer License (SDL)</b> issued by the <b>Seychelles Financial Services Authority (FSA)</b> is one of the <b>most sought-after offshore brokerage licenses globally</b>. It is widely used by <b>forex brokers, CFD platforms, and investment firms</b> due to its <b>low capital requirements, strong credibility, and cost efficiency</b>.
                    "
                badges={
                    [
                        "Forex Brokers",
                        "CFD Platforms",
                        "Securities Dealers",
                        "Trading Platforms"
                    ]
                }
                buttonText="Request a Seychelles Forex License Proposal →"
                buttonLink="/quote"
                imageSrc={require("../../../assets/images/services/securities-dealer-license-seychelles-hero.png")}
                imageAlt="Gaming License Intro"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title='Why Choose Seychelles for Forex Licensing?'
                        blocks={[
                            {
                                items:
                                    [
                                        {
                                            title: "Global Reputation",
                                            text: "The SDL is one of the most recognized offshore forex licenses."
                                        },
                                        {
                                            title: "Low Capital Requirement",
                                            text: "Only USD 50,000, compared to millions required in EU jurisdictions."
                                        },
                                        {
                                            title: "FSA Supervision",
                                            text: "Seychelles FSA is respected as a credible regulatory authority."
                                        },
                                        {
                                            title: "Tax Neutrality",
                                            text: "Foreign-sourced income is exempt from Seychelles tax."
                                        },
                                        {
                                            title: "Fast Licensing ",
                                            text: "approval in as little as 3–6 months."
                                        },


                                    ]
                            }
                        ]}
                    />

                    <LocationTimeline
                        title="What the License Covers"
                        subtitle='A licensed Securities Dealer in Seychelles may:'
                        item={
                            [
                                { text: "Act as a principal or agent in securities transactions." },
                                { text: "Operate as a forex / CFD broker." },
                                { text: "Provide market-making and liquidity services." },
                                { text: "Trade derivatives, bonds, equities, and structured products." },
                                { text: "Offer portfolio management and investment advice (with approval)." }
                            ]
                        }
                    />

                    <ServiceCards
                        title='Capital & Requirements'
                        services={
                            [
                                { text: "Minimum Paid-Up Capital: USD 50,000." },
                                { text: "Local Entity: Seychelles International Business Company (IBC) required." },
                                { text: "Resident Director & Compliance Officer: mandatory." },
                                { text: "Office Presence: local office / registered agent in Seychelles." },
                                { text: "AML/KYC Compliance: in line with FATF standards." }
                            ]
                        }
                    />

                    <FeatureCards
                        title='Benefits of a Seychelles Securities Dealer License'
                        features={
                            [
                                {
                                    title: "Global Acceptance",
                                    text: "Popular among forex brokers worldwide."
                                },
                                {
                                    title: "Affordable Entry",
                                    text: "Only USD 50,000 capital, cheaper than Cyprus or Malta."
                                },
                                {
                                    title: "Banking Access",
                                    text: "Easier onboarding than unlicensed offshore brokers."
                                },
                                {
                                    title: "Scalability",
                                    text: "Start small and expand into global trading markets."
                                },
                                {
                                    title: "Versatility",
                                    text: "License covers forex, CFDs, derivatives, and securities."
                                }
                            ]
                        }
                    />

                    <InfoBlocks
                        title="Licensing Process"
                        blocks={[
                            {
                                items:
                                    [
                                        {
                                            title: "Consultation & Structuring",
                                            text: "Define brokerage model (STP, ECN, market maker)."
                                        },
                                        {
                                            title: "Company Incorporation",
                                            text: "Register a Seychelles International Business Company (IBC)."
                                        },
                                        {
                                            title: "Application Submission",
                                            text: "Submit business plan, AML manuals, and shareholder documentation."
                                        },
                                        {
                                            title: "FSA Review",
                                            text: "Regulator performs due diligence on the company and directors."
                                        },
                                        {
                                            title: "Approval & Licensing",
                                            text: "License is typically granted within 3–6 months."
                                        }
                                    ]
                            },
                        ]}
                    />

                    {/* Timeline */}
                    <TimelineSection
                        title='Timeline & Costs'
                        items={[
                            {
                                name: "Timeline",
                                duration: "3-6 months",
                            },
                            {
                                name: "Setup Costs",
                                description: "from USD 35,000+ (legal, compliance, licensing)",
                            },
                            {
                                name: "Capital Requirement",
                                description: "USD 50,000 (deposit)",
                            },
                            {
                                name: "Annual Costs",
                                description: "regulator fees, compliance officer, audits",
                            },

                        ]}
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                { text: "Specialists in forex & brokerage licensing." },
                                { text: "End-to-end support: incorporation, license filing, compliance setup." },
                                { text: "Network of liquidity providers, PSPs, and banking partners." },
                                { text: "Comparative insights: Seychelles vs Cyprus vs Mauritius vs Western Sahara." },
                                { text: "Ongoing compliance, audit, and reporting support." }
                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    {/* Final CTA */}
                    <CTA title=
                             "
                                Looking to launch a forex brokerage or trading platform?
                             "
                         description=
                             "
                                The <b>Seychelles Securities Dealer License</b> offers <b>global credibility, low capital, and fast setup</b>.
                             "
                         buttonText='Book a Seychelles Forex License Consultation →'
                         buttonLink='/quote'
                    />
                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "What’s the capital requirement for a Seychelles forex license?",
        content: [
            { type: "answer", text: "USD 50,000." },
        ],
    },
    {
        question: "How long does licensing take?",
        content: [
            { type: "answer", text: "3–6 months." },
        ],
    },
    {
        question: "Do I need a local director?",
        content: [
            { type: "answer", text: "Yes — at least one resident director and a compliance officer." },
        ],
    },
    {
        question: "Is this license globally recognized?",
        content: [
            { type: "answer", text: "Yes — it’s one of the most widely used offshore forex licenses." },
        ],
    },
    {
        question: "Why choose Seychelles over Western Sahara or Mwali?",
        content: [
            { type: "answer", text: "Stronger FSA recognition, lower capital than Malta/Cyprus, globally respected." },
        ],
    },
];


const testimonialsData =
    [
        {
            quote: "We obtained our forex brokerage license in Seychelles. Offshore Advisory made the FSA process fast and transparent.",
            author: "Daniel S.",
            role: "FX Broker CEO"
        },
        {
            quote: "The Seychelles SDL gave us global credibility at a fraction of the EU cost. Offshore Advisory provided full compliance support.",
            author: "Irina K.",
            role: "FinTech Entrepreneur"
        }
    ]
;